export default {
	title: 'The DTC Blockchain Explorer',
	allFilters:'All Filters',
	addresses:'Addresses',
	contract:'Contract',
	token:'Token',
	nameTags:'Name Tags',
	domainNames:'Domain Names',
	labels:'Labels',
	websites:'Websites',
	searchPlaceholder:'Search by Address / Txn Hash / Block / Token',
	latestBlocks:'Latest Blocks',
	latestTransactions:'Latest Transactions',
	viewAllBlocks:'View all blocks',
	viewAllTransactions:'View all transactions',
	home:'Home',
	blockchain:'Blockchain',
	transactions:'Transactions',
	txn:'Txn',
	pendingTransactions:'Pending Transactions',
	blocks:'Block',
	totalOf:'Total of',
	dateTime:'Date Time (UTC)',
	validator:'Validator',
	gasUsed:'Gas Used',
	gasLimit:'Gas Limit',
	reward:'Reward',
	burntFees:'Burnt Fees (DTC)',
	overview:'Overview',
	blockHeight:'Block Height',
	blockHeightSummary:'Also known as Block Number. The block height, which indicates the length of the blockchain, increases after the addition of the new block.',
	timestamp:'Timestamp',
	timestampSummary:'The date and time at which a block is validated.',
	transactionsSummary:'The number of transactions in the block. Internal transaction is transactions as a result of contract execution that involves BNB value.',
	validatorSummary:'Validator who successfully included the block onto the blockchain.',
	blockReward:'Block Reward',
	blockRewardSummary:'For each block, the miner is rewarded with a finite amount of BNB on top of the fees paid for all transactions in the block.',
	difficulty:'Difficulty',
	difficultySummary:'The amount of effort required to validate a new block. The difficulty algorithm may adjust according to time.',
	totalDifficulty:'Total Difficulty',
	totalDifficultySummary:'Total difficulty of the chain until this block.',
	size:'Size',
	sizeSummary:"The block size is actually determined by the block's gas limit.",
	gasUsedSummary:'The total gas used in the block and its percentage of gas filled in the block.',
	gasLimitSummary:'Total gas limit provided by all transactions in the block.',
	extraData:'Extra Data',
	extraDataSummary:'Any data that can be included by the validator in the block.',
	hash:'Hash',
	hashSummary:'The hash of the block header of the current block.',
	parentHash:' Parent Hash',
	parentHashSummary:'The hash of the block from which this block was generated, also known as its parent block.',
	sha3Uncles:'Sha3Uncles',
	sha3UnclesSummary:'The mechanism which Ethereum Javascript RLP encodes an empty string.',
	moreThan:'More than',
	transactionsFound:'transactions found',
	transactionHash:'Transaction Hash',
	method:'Method',
	from:'From',
	to:'To',
	value:'Value',
	txnFee:'Txn Fee',
	transactionFee:'Transaction Fee',
	internalTxns:'Internal Transactions',
	log:'Log',
	state:'State',
	transactionHashSummary:'A TxHash or transaction hash is a unique 66-character identifier that is generated whenever a transaction is executed.',
	status:'Status',
	statusSummary:'The status of the transaction.',
	blocksSummary:'Number of the block in which the transaction is recorded. Block confirmations indicate how many blocks have been added since the transaction was produced.',
	txnTimestampSummary:'The date and time at which a transaction is validated.',
	transactionAction:'Transaction Action',
	transactionActionSummary:'Highlighted events of the transaction.',
	fromSummary:'The sending party of the transaction.',
	toSummary:'The receiving party of the transaction (could be a contract address).',
	valueSummary:'The value being transacted in BNB and fiat value. Note: You can click the fiat value (if available) to see historical value at the time of transaction.',
	transactionFeeSummary:'Amount paid to the validator for processing the transaction.',
	gasPrice:'Gas Price',
	gasPriceSummary:'Cost per unit of gas specified for the transaction, in BNB and Gwei. The higher the gas price the higher chance of getting included in a block.',
	inputData:'Input Data',
	inputDataSummary:'Additional data included for this transaction. Commonly used as part of contract interaction or as a message sent to the recipient.',
	copySuccessful:'Copy successful',
	otherAttributes:'Other Attributes',
	otherAttributesSummary:'Other data related to this transaction.',
	burntFeesSummary:'Total amount of BNB burnt from this tx.',
	usageByTxn:'Usage by Txn',
	usageByTxnSummary:'Maximum amount of gas allocated for the transaction & the amount eventually used. Normal BNB transfers involve 21,000 gas units while contracts involve higher values.',
	typeTraceAddress:'Type Trace Address',
	name:'Name',
	topics:'Topics',
	data:'Data',
	viewMore:'View More',
	tokenTransfers:'Token Transfers (DEP-20)',
	producedBlocks:'Produced Blocks',
	validatorSetInfo:'Validator Set Info',
	parentTransactionHash:'Parent Transaction Hash',
	tokenTransferEvents:'Token Transfer Events',
	feeAddress:'Fee Address',
	BCFeeAddress:'BC Fee Address',
	votingPower:'Voting Power',
	incoming:'Incoming',
	systemAbnormality:'System abnormality',
	in3secs:'in 3 secs',
	feeRecipient:'Fee Recipient',
	success:'Success',
	fail:'Fail',
	times:'times',
	tokenAmountRanking:'Token Amount Ranking',
	tokenTradingList:'Token trading list',
	amount:'Amount',
	contractAddressSummary:'The contract address is a unique identifier used in blockchain networks to represent smart contracts',
	type:'type',
	holders:'Holders',
	totalSupply:'Total Supply',
	noData:'No data',
	otherInfo:'Other Info',
	percentage:'Percentage',
	Info:'Info',
	transfers:'Transfers',
	quantity:'Quantity',
	tokensTransferred:'ERC-20 Tokens Transferred',
	tokensTransferredSummary:'List of ERC-20 tokens transferred in the transaction.',
	balance:'balance',
}